import { render, staticRenderFns } from "./AdjustmentsFormPublisher.vue?vue&type=template&id=137e82de&scoped=true"
import script from "./AdjustmentsFormPublisher.vue?vue&type=script&lang=js"
export * from "./AdjustmentsFormPublisher.vue?vue&type=script&lang=js"
import style0 from "./AdjustmentsFormPublisher.vue?vue&type=style&index=0&id=137e82de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137e82de",
  null
  
)

export default component.exports